/* Typographic characters by code point, so this file stays ASCII. */
const SINGLE_QUOTES = new RegExp('[\\u{2018}\\u{2019}\\u{201A}\\u{201B}]', 'gu');
const DOUBLE_QUOTES = new RegExp('[\\u{201C}\\u{201D}\\u{201E}\\u{201F}]', 'gu');
const NUMBER_RANGE_DASH = new RegExp('(\\d)\\s*\\u{2013}\\s*(?=\\d)', 'gu');
const LONG_DASH = new RegExp('[ \\t]*[\\u{2013}\\u{2014}][ \\t]*', 'gu');
const ELLIPSIS = new RegExp('\\u{2026}', 'gu');

/**
 * Rewrites the typographic punctuation a model sometimes writes into the plain ASCII Pieve shows:
 * curly quotes become straight quotes, an en dash between two numbers becomes a hyphen ("3-5"),
 * any other en or em dash becomes " - ", and an ellipsis character becomes three dots. The web
 * applies it when it shows replies and run results; generated conversation titles are stored
 * already rewritten.
 */
const normalizeTypography = (text) => {
  return String(text ?? '')
    .replace(SINGLE_QUOTES, "'")
    .replace(DOUBLE_QUOTES, '"')
    .replace(NUMBER_RANGE_DASH, '$1-')
    .replace(LONG_DASH, ' - ')
    .replace(ELLIPSIS, '...');
};

export default normalizeTypography;
